import { createEnv } from "@t3-oss/env-core";
import { z } from "zod";

export const env = createEnv({
	server: {
		SERVER_URL: z.string().url().optional(),
	},

	/**
	 * The prefix that client-side variables must have. This is enforced both at
	 * a type-level and at runtime.
	 */
	clientPrefix: "VITE_",

	client: {
		VITE_APP_TITLE: z.string().min(1).optional(),
		VITE_API_BASE_URL: z
			.string()
			.url()
			.default("http://localhost:8000")
			.describe("Backend API base URL"),
		VITE_AGENT_STREAM_MODE: z
			.enum(["live", "mock", "record"])
			.default("live")
			.describe("Controls how agent execution streams are sourced in dev"),
		VITE_AGENT_STREAM_FIXTURE_URL: z
			.string()
			.min(1)
			.default("/mocks/agent-stream.json")
			.describe("Fixture used when VITE_AGENT_STREAM_MODE=mock"),
		VITE_SENTRY_DSN: z
			.string()
			.url()
			.optional()
			.describe("Sentry DSN for error tracking and performance monitoring"),
		VITE_POSTHOG_API_KEY: z.string().optional().describe("PostHog API key for product analytics"),
		VITE_POSTHOG_HOST: z
			.string()
			.url()
			.default("https://us.i.posthog.com")
			.describe("PostHog host URL"),
	},

	/**
	 * What object holds the environment variables at runtime. This is usually
	 * `process.env` or `import.meta.env`.
	 */
	runtimeEnv: import.meta.env,

	/**
	 * By default, this library will feed the environment variables directly to
	 * the Zod validator.
	 *
	 * This means that if you have an empty string for a value that is supposed
	 * to be a number (e.g. `PORT=` in a ".env" file), Zod will incorrectly flag
	 * it as a type mismatch violation. Additionally, if you have an empty string
	 * for a value that is supposed to be a string with a default value (e.g.
	 * `DOMAIN=` in an ".env" file), the default value will never be applied.
	 *
	 * In order to solve these issues, we recommend that all new projects
	 * explicitly specify this option as true.
	 */
	emptyStringAsUndefined: true,
});
